// extracted by mini-css-extract-plugin
export default {"container":"Cookies_container__qw2YX","heading":"Cookies_heading__amNRq","policy":"Cookies_policy__Jge0K","subHeading":"Cookies_subHeading__2gI8G","content":"Cookies_content__7K0g0"};